"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quiz/survey-type.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquiz%2Fsurvey-type.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyTypeToJSON = exports.surveyTypeFromJSON = exports.SurveyType = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.quiz.proto';
var SurveyType;
(function (SurveyType) {
    SurveyType["INVALID_SURVEY_TYPE"] = "INVALID_SURVEY_TYPE";
    SurveyType["ONBOARDING_INTEREST"] = "ONBOARDING_INTEREST";
    SurveyType["EMPLOYMENT"] = "EMPLOYMENT";
    SurveyType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SurveyType || (exports.SurveyType = SurveyType = {}));
function surveyTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SURVEY_TYPE':
            return SurveyType.INVALID_SURVEY_TYPE;
        case 1:
        case 'ONBOARDING_INTEREST':
            return SurveyType.ONBOARDING_INTEREST;
        case 2:
        case 'EMPLOYMENT':
            return SurveyType.EMPLOYMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SurveyType.UNRECOGNIZED;
    }
}
exports.surveyTypeFromJSON = surveyTypeFromJSON;
function surveyTypeToJSON(object) {
    switch (object) {
        case SurveyType.INVALID_SURVEY_TYPE:
            return 'INVALID_SURVEY_TYPE';
        case SurveyType.ONBOARDING_INTEREST:
            return 'ONBOARDING_INTEREST';
        case SurveyType.EMPLOYMENT:
            return 'EMPLOYMENT';
        case SurveyType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.surveyTypeToJSON = surveyTypeToJSON;
//# sourceMappingURL=survey-type.js.map